var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIconPurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7932 14.7664L12.0846 11.0548C13.1751 9.70071 13.705 7.98002 13.5651 6.24701C13.4252 4.51399 12.6262 2.90057 11.3326 1.73891C10.039 0.577249 8.34923 -0.044221 6.61121 0.00245059C4.87319 0.0491222 3.2192 0.760382 1.98979 1.98979C0.760382 3.2192 0.0491222 4.87319 0.00245059 6.61121C-0.044221 8.34923 0.577249 10.039 1.73891 11.3326C2.90057 12.6262 4.51399 13.4252 6.24701 13.5651C7.98002 13.705 9.70071 13.1751 11.0548 12.0846L14.7664 15.7961C14.9034 15.9284 15.0868 16.0016 15.2772 16C15.4676 15.9983 15.6498 15.9219 15.7844 15.7873C15.919 15.6527 15.9954 15.4705 15.9971 15.2801C15.9987 15.0897 15.9255 14.9063 15.7932 14.7693V14.7664ZM1.48208 6.80728C1.48208 5.75388 1.79446 4.72414 2.37971 3.84828C2.96497 2.97242 3.7968 2.28978 4.77003 1.8867C5.74326 1.48361 6.81417 1.37818 7.84731 1.58375C8.88046 1.78931 9.82945 2.29662 10.5743 3.04154C11.3191 3.78646 11.8263 4.73552 12.0317 5.76869C12.2371 6.80187 12.1315 7.87276 11.7283 8.84593C11.3251 9.8191 10.6423 10.6509 9.76641 11.236C8.89047 11.8211 7.86068 12.1334 6.80728 12.1332C5.39536 12.1315 4.04177 11.5698 3.04345 10.5713C2.04514 9.57288 1.48362 8.21921 1.48208 6.80728Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIconPurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchIconPurple.96897990b315827d0a1361591ff120e4.svg";